(function () {
  'use strict';

  var LIST_NAME = 'Quick n Dirty Free Gifts';

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function getCurrencyCode() {
    if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
    return 'USD';
  }

  function pushElevar(entries) {
    window.ElevarDataLayer = window.ElevarDataLayer || [];
    window.ElevarDataLayer.push({
      event: 'dl_add_to_cart',
      user_properties: {},
      ecommerce: {
        currencyCode: getCurrencyCode(),
        add: {
          actionField: { list: LIST_NAME },
          products: entries.map(function (e) {
            return {
              id: String(e.product_id),
              product_id: String(e.product_id),
              variant_id: String(e.variant_id),
              name: e.name || '',
              brand: e.brand || '',
              category: e.category || '',
              variant: e.variant || '',
              price: ((e.price || 0) / 100).toFixed(2),
              quantity: '1',
              list: LIST_NAME,
              sku: e.sku || '',
              handle: e.handle || ''
            };
          })
        }
      }
    });
  }

  function Module(root) {
    this.root = root;
    this.formId = root.getAttribute('data-qnd-form') || '';
    this.triggers = (root.getAttribute('data-qnd-triggers') || '')
      .split(',')
      .map(function (v) { return parseInt(v, 10); })
      .filter(function (v) { return !isNaN(v); });

    this.intro = root.querySelector('[data-qnd-intro]');
    this.introReady = this.intro ? this.intro.textContent : '';
    this.introNeedsJersey = 'Pick a size for each. Your jersey goes into the cart with them.';
    this.button = root.querySelector('[data-qnd-add]');
    this.message = root.querySelector('[data-qnd-message]');
    this.jerseyInCart = false;
    this.added = false;
    this.busy = false;
    this.rows = [];

    var self = this;
    Array.prototype.forEach.call(root.querySelectorAll('[data-qnd-gift]'), function (el) {
      var row = self.buildRow(el);
      if (row) self.rows.push(row);
    });

    if (this.rows.length < 2) { root.hidden = true; return; }

    this.button.addEventListener('click', function () { self.add(); });
    this.bindCartWatchers();
    this.render();
    this.refreshCart();
  }

  Module.prototype.buildRow = function (el) {
    var data = parseJSON(el.querySelector('[data-qnd-data]'));
    if (!data || !data.variants || !data.variants.length) return null;

    var row = {
      el: el,
      data: data,
      selects: Array.prototype.slice.call(el.querySelectorAll('[data-qnd-option]')),
      variant: null
    };

    var self = this;
    row.selects.forEach(function (select) {
      select.addEventListener('change', function () {
        self.added = false;
        self.root.classList.remove('is-added');
        self.setMessage(null, '');
        self.resolveVariant(row);
        self.render();
      });
    });

    this.resolveVariant(row);
    return row;
  };

  Module.prototype.resolveVariant = function (row) {
    var chosen = row.selects.map(function (s) { return s.value; });
    if (chosen.some(function (v) { return !v; })) { row.variant = null; return; }
    row.variant = row.data.variants.filter(function (v) {
      return v.options.length === chosen.length && v.options.every(function (opt, i) { return opt === chosen[i]; });
    })[0] || null;
  };

  Module.prototype.allChosen = function () {
    return this.rows.every(function (row) { return !!row.variant; });
  };

  Module.prototype.soldOut = function () {
    return this.rows.some(function (row) { return row.variant && !row.variant.available; });
  };

  Module.prototype.render = function () {
    var btn = this.button;
    if (this.intro && this.introReady) {
      this.intro.textContent = this.jerseyInCart ? this.introReady : this.introNeedsJersey;
    }
    if (this.busy) { btn.disabled = true; btn.textContent = 'Adding…'; return; }
    if (this.added) { btn.disabled = true; btn.textContent = 'Added to cart'; return; }
    if (!this.allChosen()) { btn.disabled = true; btn.textContent = 'Choose your sizes'; return; }
    if (this.soldOut()) { btn.disabled = true; btn.textContent = 'Sold out'; return; }
    btn.disabled = false;
    btn.textContent = this.jerseyInCart ? 'Add both free' : 'Add jersey + both free';
  };

  Module.prototype.setMessage = function (kind, text) {
    if (!this.message) return;
    this.message.textContent = text || '';
    this.message.hidden = !text;
    this.message.classList.toggle('qnd-gifts__message--error', kind === 'error');
  };

  Module.prototype.jerseyVariantId = function () {
    var form = this.formId ? document.getElementById(this.formId) : null;
    if (!form) form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    var input = form.querySelector('[name="id"]');
    if (!input) return null;
    var id = parseInt(input.value, 10);
    return isNaN(id) ? null : id;
  };

  Module.prototype.refreshCart = function () {
    var self = this;
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (cart) {
        if (cart && cart.items) {
          self.jerseyInCart = cart.items.some(function (item) {
            return self.triggers.indexOf(item.product_id) !== -1;
          });
        }
        self.render();
        return cart;
      });
  };

  Module.prototype.bindCartWatchers = function () {
    var self = this;
    ['cart:updated', 'cart:build', 'cart:open'].forEach(function (name) {
      document.addEventListener(name, function () { self.refreshCart(); });
    });
    document.addEventListener('click', function (evt) {
      var target = evt.target.closest ? evt.target.closest('[data-add-to-cart]') : null;
      if (target) window.setTimeout(function () { self.refreshCart(); }, 900);
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) self.refreshCart();
    });
  };

  Module.prototype.add = function () {
    if (this.busy || this.added || !this.allChosen() || this.soldOut()) return;

    var self = this;
    var items = this.rows.map(function (row) { return { id: row.variant.id, quantity: 1 }; });
    var withJersey = false;

    if (!this.jerseyInCart) {
      var jerseyId = this.jerseyVariantId();
      if (!jerseyId) {
        this.setMessage('error', 'Choose your jersey size first.');
        return;
      }
      items.unshift({ id: jerseyId, quantity: 1 });
      withJersey = true;
    }

    this.busy = true;
    this.setMessage(null, '');
    this.render();

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (resp) {
        if (!resp.ok) {
          return resp.json().catch(function () { return {}; }).then(function () {
            self.busy = false;
            self.setMessage('error', 'One of those sizes is not available right now.');
            self.render();
            return null;
          });
        }
        return resp.json().then(function () {
          return self.refreshCart().then(function (cart) {
            self.busy = false;
            self.added = true;
            self.root.classList.add('is-added');
            try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch (e) {}
            try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
            try {
              pushElevar(self.rows.map(function (row) {
                return {
                  product_id: row.data.product_id,
                  variant_id: row.variant.id,
                  name: row.data.title,
                  brand: row.data.vendor,
                  category: row.data.type,
                  variant: row.variant.title,
                  price: row.variant.price,
                  sku: row.variant.sku,
                  handle: row.data.handle
                };
              }));
            } catch (e) {}
            self.setMessage('success', withJersey
              ? 'Jersey added too. Both gifts come off at checkout.'
              : 'Added. Both gifts come off at checkout.');
            self.render();
            return cart;
          });
        });
      })
      .catch(function () {
        self.busy = false;
        self.setMessage('error', 'Something went wrong. Please try again.');
        self.render();
      });
  };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-qnd-gifts]'), function (root) {
      if (root.qndReady) return;
      root.qndReady = true;
      new Module(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
